import React, { useEffect, useContext } from "react"
import { FormattedMessage } from "react-intl"
import Link, { navigate } from "../link.js"
import SEO from "../components/seo.js"
import StreamStoriesHomePage from "../components/streams/stream-stories-homepage.js"
import CareerFit from "../../static/assets/images/home-page-career-fit.png"
import CareerPlanning from "../../static/assets/images/home-page-career-planning.jpg"
import Humanities from "../../static/assets/images/home-page-career-humanities.png"
import Law from "../../static/assets/images/home-page-career-law.png"
import Arts from "../../static/assets/images/home-page-career-arts.png"
import Trades from "../../static/assets/images/home-page-career-trades.png"
import Science from "../../static/assets/images/home-page-career-science.png"
import Business from "../../static/assets/images/home-page-career-business.png"
import DashboardScreen from "../../static/assets/images/Wingspans-homepage-dashboard.jpg"
import PorfolioScreen from "../../static/assets/images/Wingspans-homepage-portfolio.jpg"
import { FirebaseContext } from "../components/Firebase/index"
import LoadingSpinner from "../components/loading/LoadingSpinner.js"
import "./index.css"
import StreamCompaniesHomePage from "../components/streams/stream-companies-homepage.js"
import PromoHero from "../components/promotional/PromoHero.js"
import SimpleLocalize from "../components/SimpleLocalize.js"

const IndexPage = (props) => {
  const { user, loading, subdomainConfig } = useContext(FirebaseContext)
  const { subdomain } = subdomainConfig

  useEffect(() => {
    if (user?.membership?.active === true) {
      navigate("/dashboard", { replace: true })
    } else if (user?.membership?.active === false) {
      // can use this for resubscription redirect
    }
  }, [user])

  useEffect(() => {
    if (subdomain && !user) {
      navigate("/login", { replace: true })
    }
  }, [user])

  return (
    <SimpleLocalize {...props}>
      <section>
        {loading || user?.membership?.active === true ? (
          <LoadingSpinner />
        ) : (
          <>
            <SEO title={"Wingspans"} />

            <PromoHero {...props} page="home" isVideo={true} />

            <section className="intro home-intro">
              <div className="inner inner-intro">
                <div className="lead component-lead component-lead-default">
                  <h2>
                    <FormattedMessage id="home-intro-title" defaultMessage="Over 700 Real-World Stories About Work" />
                  </h2>
                  <p>
                    <FormattedMessage
                      id="home-intro-desc"
                      defaultMessage="Stories provide a glimpse into the working world through the
                    eyes of real people in a variety of jobs. Filled with
                    invaluable advice from people seasoned with experience,
                    ranging from data scientists to cartoonists, our in-depth
                    interviews are an authentic portrait of the modern and
                    ever-changing workplace"
                    />
                  </p>
                </div>
              </div>
            </section>

            <StreamStoriesHomePage />

            <section className="profiles">
              <div className="inner inner-mentors">
                <blockquote className="component-blockquote component-blockquote-default">
                  <p>
                    <FormattedMessage
                      id="home-profile-quote"
                      defaultMessage="“I am always doing that which I cannot do, in order that I may
                  learn how to do it”"
                    />
                  </p>
                  <cite>&mdash; Pablo Picasso</cite>
                </blockquote>

                <div className="career-profiles">
                  <div className="call-to-action component-call-to-action component-call-to-action-default">
                    <h2>
                      <FormattedMessage id="home-career-profiles" defaultMessage="Rich Career Profiles" />
                    </h2>
                    <p>
                      <FormattedMessage
                        id="home-career-profiles-desc"
                        defaultMessage="Hundreds of career profiles with multidimensional content to
                      help the next generation prepare for a successful future"
                      />
                    </p>
                    <Link type="button" className="button component-button component-button-default" to="/career/data-scientist">
                      <FormattedMessage id="view-sample-profile" defaultMessage="View Sample Profile" />
                    </Link>
                  </div>
                  <div className="stream stream-careers-homepage">
                    <div className="component-card component-card-career">
                      <div className="category-image">
                        <img src={Science} alt="career" />
                      </div>
                      <div className="category-container">
                        <div className="eyebrow component-eyebrow">
                          <FormattedMessage id="home-career-category-1" defaultMessage=" Science & Technology" />
                        </div>
                        <div className="subcategories">
                          <FormattedMessage
                            id="home-career-subcategory-1"
                            defaultMessage="Data Scientist, Machine Learning Engineer, Ecologist,
                          Aerospace Engineer, Materials Scientist, Chemist"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="component-card component-card-career">
                      <div className="category-image">
                        <img src={Humanities} alt="career" />
                      </div>
                      <div className="category-container">
                        <div className="eyebrow component-eyebrow">
                          <FormattedMessage id="home-career-category-2" defaultMessage="Humanities" />
                        </div>
                        <div className="subcategories">
                          <FormattedMessage
                            id="home-career-subcategory-2"
                            defaultMessage="Anthropologist, Historian, Philosopher, Literary Critic,
                          Political Scientist, Theologist, Visual Artist,
                          Archaeologist"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="component-card component-card-career">
                      <div className="category-image">
                        <img src={Law} alt="career" />
                      </div>
                      <div className="category-container">
                        <div className="eyebrow component-eyebrow">
                          <FormattedMessage id="home-career-category-3" defaultMessage="Legal" />
                        </div>
                        <div className="subcategories">
                          <FormattedMessage
                            id="home-career-subcategory-3"
                            defaultMessage="Judge, Lawyer, Paralegal, Criminal Investigator, Police
                          Officer, Criminologist, FBI Investigator, Forensic
                          Psychiatrist"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="component-card component-card-career">
                      <div className="category-image">
                        <img src={Arts} alt="career" />
                      </div>
                      <div className="category-container">
                        <div className="eyebrow component-eyebrow">
                          <FormattedMessage id="home-career-category-4" defaultMessage="Arts" />
                        </div>
                        <div className="subcategories">
                          <FormattedMessage
                            id="home-career-subcategory-4"
                            defaultMessage="Television Writer, Director, Composer, Radio Reporter,
                          Musician, Talent Agent, Cinematographer, Editor"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="component-card component-card-career">
                      <div className="category-image">
                        <img src={Trades} alt="career" />
                      </div>
                      <div className="category-container">
                        <div className="eyebrow component-eyebrow">
                          <FormattedMessage id="home-career-category-5" defaultMessage="Trades" />
                        </div>
                        <div className="subcategories">
                          <FormattedMessage
                            id="home-career-subcategory-5"
                            defaultMessage=" Pipe Fitter, Electrician, Foreman, Drafter, Painter,
                          Carpenter, Builder, Landscaper, Machinist, Line
                          Constructor"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="component-card component-card-career">
                      <div className="category-image">
                        <img src={Business} alt="career" />
                      </div>
                      <div className="category-container">
                        <div className="eyebrow component-eyebrow">
                          <FormattedMessage id="home-career-category-6" defaultMessage="Business/Finance" />
                        </div>
                        <div className="subcategories">
                          <FormattedMessage
                            id="home-career-subcategory-6"
                            defaultMessage="Entrepreneur, Investment Banker, Auditor, Private Equity
                          Professional, Accountant, Actuary, Insurance Agent,
                          Venture Capitalist"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="career-fit">
              <div className="inner inner-career-fit">
                <div className="career-fit-lead">
                  <img src={CareerFit} alt="career fit" />
                  <div className="career-fit-cta">
                    <h2>
                      <FormattedMessage id="home-career-fit-title" defaultMessage="Find the Right Career Fit" />
                    </h2>
                    <p>
                      <FormattedMessage
                        id="home-career-fit-desc"
                        defaultMessage="We have built-in algorithms that recommend careers we think
                      will strike their fancy"
                      />
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="career-tools">
              <div className="inner inner-career-tools">
                <div className="stream stream-career-tools-homepage">
                  <div className="card component-card component-card-tools">
                    <img src={PorfolioScreen} alt="portfolio" />
                    <h2 className="title">
                      <FormattedMessage id="home-personalized-portfolio" defaultMessage="Personalized Portfolios" />
                    </h2>
                    <p className="excerpt">
                      <FormattedMessage
                        id="home-personalized-portfolio-desc"
                        defaultMessage="A shareable profile highlights unique interests, skills, and
                      abilities"
                      />
                    </p>
                  </div>
                  <div className="card component-card component-card-tools">
                    <img src={DashboardScreen} alt="dashboard" />
                    <h2 className="title">
                      <FormattedMessage id="home-motivational" defaultMessage="Motivational" />
                    </h2>
                    <p className="excerpt">
                      <FormattedMessage
                        id="home-motivational-desc"
                        defaultMessage="Students stay motivated and get on their way to a rich and
                      meaningful career! They earn points and unlock rewards"
                      />
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="career-planning">
              <div className="inner inner-career-planning">
                <blockquote className="component-blockquote component-blockquote-home">
                  <p>
                    <FormattedMessage id="home-career-planning-quote" defaultMessage="“If you can see it you can be it”" />
                  </p>
                  <cite>
                    <FormattedMessage
                      id="home-career-planning-quote-by"
                      defaultMessage="— Former Commissioner of Education, State of Rhode
                    Island"
                    />
                  </cite>
                </blockquote>
                <div className="career-planning-lead">
                  <div className="career-planning-cta">
                    <h2>
                      <FormattedMessage id="home-career-planning-tools" defaultMessage="Career Planning Tools" />
                    </h2>
                    <p>
                      <FormattedMessage
                        id="home-career-planning-tools-desc"
                        defaultMessage="New self-knowledge is turned into an actionable plan for the
                      future. Students use our proprietary workflow to develop
                      timelines to achieve the career they always wanted"
                      />
                    </p>
                  </div>
                  <img src={CareerPlanning} alt="curriculum" />
                </div>
              </div>
            </section>

            <section className="industries">
              <div className="inner inner-industries">
                <div className="stream stream-industries-homepage">
                  <div className="inner inner-industries-quote">
                    <blockquote className="component-blockquote component-blockquote-home">
                      <p>“Ma ka hana ka ‘ike”</p>
                      <cite>
                        <FormattedMessage
                          id="home-hawaiian-proverb"
                          defaultMessage="— Hawaiian proverb that means “In working one
                        learns”"
                        />
                      </cite>
                    </blockquote>
                  </div>
                  <StreamCompaniesHomePage />
                </div>

                <div className="call-to-action component-call-to-action component-call-to-action-default">
                  <h2>
                    <FormattedMessage id="home-industry-partners" defaultMessage="Industry Partners" />
                  </h2>
                  <p>
                    <FormattedMessage id="home-industry-partners-desc" defaultMessage="Help students make connections between careers and industry" />
                  </p>
                  <Link type="button" className="button component-button component-button-default" to="/signup/employers">
                    <FormattedMessage id="home-industry-partners-cta" defaultMessage="Partner With Us" />
                  </Link>
                </div>
              </div>
            </section>

            <section className="signup" style={{ backgroundColor: "#54d1c1" }}>
              <div className="inner inner-signup">
                <div className="call-to-action component-call-to-action component-call-to-action-signup">
                  <blockquote className="component-blockquote component-blockquote-default-inline">
                    <p>
                      <FormattedMessage id="home-educator-employer-quote" defaultMessage="“Each other’s lives are our best textbooks”" />
                    </p>
                    <cite>– Gloria Steinem</cite>
                  </blockquote>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      gap: "1rem",
                    }}
                  >
                    <Link type="button" className="button component-button component-button-signup" to="/signup/educators">
                      <FormattedMessage id="home-educators-cta" defaultMessage="Educators" />
                    </Link>

                    <Link type="button" className="button component-button component-button-signup" to="/signup/employers">
                      <FormattedMessage id="home-employers-cta" defaultMessage="Employers" />
                    </Link>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </section>
    </SimpleLocalize>
  )
}
export default IndexPage
